import { useEffect, useState } from 'react';
import moment from 'moment';
import { fetchassocation } from '../../api/pages/assocationApi'
import {
    IPictureTextCardItem,
    IPictureTextCardProps,
} from './components/interestbanner/types';
import {
    NumberTabItem,
    MemberTabGroup,
    MumberTabItem,
} from './components/numbertab/types'
//  预请求
let preRequest: any = {
    fetchassocation: fetchassocation()
}
const useAssocationHooks = () => {

    const [activity, setActivity] = useState<IPictureTextCardProps>(() => {
        return {
            list: []
        }
    })
    const [memberTabGroup, setMemberTabGroup] = useState<MemberTabGroup>(() => {
        return {
            listSortByTime: [],
            listSortByChar: []
        }
    });


    useEffect(() => {
        (async () => {
            const res = await (preRequest.fetchassocation || fetchassocation())
                .catch(() => {

                })
            delete preRequest.fetchassocation;
            if (res) {
                const data = res.body.result.pageData;
                const a = data.recentActivity || {};
                const aList: IPictureTextCardItem[] = Array.isArray(a.list) ? a.list : [];
                setActivity({
                    list: aList.map((item, index) => {
                        return {
                            key: `${index}${item.title}`,
                            title: item.title,
                            text: item.text,
                            img: item.img,
                            signingUp: !!item.signingUp,
                            btnLink: item.btnLink,
                            btnText: item.btnText
                        };
                    })
                });

                const n = data.doctorMember || {};

                const nList: NumberTabItem[] = Array.isArray(n.list) ? n.list : [];

                const nListSortByTime = (() => {
                    const sortBy = (a: NumberTabItem, b: NumberTabItem) => {
                        if (!a.entryTime || !b.entryTime) {
                            return 0;
                        }
                        const aTime = moment(a.entryTime);
                        const bTime = moment(b.entryTime);
                        if (aTime.isSame(bTime)) {
                            return 0;
                        }
                        return bTime.isBefore(aTime)
                            ? -1
                            : 1;
                    }
                    return [...nList].sort(sortBy);
                })();

                const nListSortByChar = (() => {
                    const sortBy = (a: NumberTabItem, b: NumberTabItem) => {
                        const aName = a.name ?? '';
                        const bName = b.name ?? '';
                        return aName.localeCompare(bName);
                    }
                    return [...nList].sort(sortBy);
                })();

                const getMemberListGroup = (list: NumberTabItem[]) => {
                    const resList: MumberTabItem[][] = [];
                    for (let i = 0; list.slice(i * 24, (i + 1) * 24).length > 0; i++) {
                        const theL = list.slice(i * 24, (i + 1) * 24)
                            .map((item, index) => ({
                                key: `${index}${item.name}`,
                                name: item.name,
                                text: item.text,
                                link: item.link
                            }));
                        resList.push(theL);
                    }
                    return resList;
                }

                setMemberTabGroup({
                    listSortByTime: getMemberListGroup(nListSortByTime),
                    listSortByChar: getMemberListGroup(nListSortByChar)
                })
            }
        })();
    }, []);

    return {
        activity,
        memberTabGroup
    }

}

export default useAssocationHooks;
